export const SPACE = ' ';
export const THREE_DOTS = '...';
export const DESCRIPTION_OFFSET = 25;
export const MAX_COMMENT_PREVIEW_LENGTH = 340;
export const MINIMUM_SEARCH_STRING_LENGTH = 2;
export const MAX_CHARACTERS_ALLOWED = 30;
export const SEARCH_DELAY = 500;
export const SEARCH_DELAY_MOBILE = 200;
export const SEARCH_DEBOUNCE_DELAY = 300;
export const IMAGE_ASPECT_RATIO = 0.525;
export const MAX_IMAGE_ASPECT_RATIO = 1.5;
export const MAX_IMAGE_SCREEN_HEIGHT_PERCENTAGE = 0.8; // 80%

export const MAX_DISPLAYED_ROOMS = 5;
export const ROOMS_PREVIEW_LENGTH = 2;
export const TAG_MAX_LENGTH = 50;
export const MAX_CHARACTERS_STORY_NOTIFICATION = 100;
export const MAX_ROOMS_CHARACTERS_DISPLAYED_SM_OR_UP = 70;
export const MAX_ROOMS_CHARACTERS_DISPLAYED_XS = 60;
export const MAX_NUMBER_OF_CHARACTERS_FOR_RESULTS = 50;
export const MAX_LINES_FOR_ROOMS_DESCRIPTION = 4;
export const MAX_NUMBER_OF_CHARACTERS_FOR_ROOMS_DESCRIPTION = 300;

export const relationshipTypesFallbackList = [
  'me',
  'familymember',
  'child',
  'parent',
  'friend',
];
